(ns bp-libs.design-system.components.highlights)

(defn thumb-container
  [thumb]
  [:div {:class ["w-1/5 last:pr-0"]}
   [:div {:tab-index -1
          :class ["w-full select-none shrink-0 snap-always rounded-lg outline-none thumb"]}
    thumb]])

(defn tv-highlights
  [items]
  (let [items (take 5 items)]
    [:div {:class ["w-full flex"
                   "items-center justify-center"]}
     (into [:div {:class ["w-[80%] flex"]}]
           (mapv thumb-container items))]))
